export const formatDisplayName = (fullName: string) => {
  const names = fullName.trim().split(' ');
  if (names.length <= 2) return fullName;

  const firstName = names[0];
  const lastName = names[names.length - 1];
  const middleNames = names.slice(1, -1).map(name => `${name[0]}.`).join(' ');

  return `${firstName} ${middleNames} ${lastName}`;
};

export const getInitials = (fullName: string) => {
  const names = fullName.trim().split(' ').filter(name => name.length > 0);
  
  if (names.length === 0) return '';
  if (names.length === 1) return names[0][0].toUpperCase();
  
  // Pega a primeira letra do primeiro nome e do último nome
  const firstInitial = names[0][0].toUpperCase();
  const lastInitial = names[names.length - 1][0].toUpperCase();
  
  return `${firstInitial}${lastInitial}`;
};